import {
  Box,
  PanelSection,
  SkeletonAvatar,
  SkeletonTag,
  SkeletonText,
} from '@dev-spendesk/grapes';

export const CardTransactionDetailsSkeleton = () => {
  return (
    <>
      <div>
        <Box
          variant="secondary"
          className="mb-16 flex min-h-[80px] items-center"
        >
          &nbsp;
        </Box>
      </div>
      <PanelSection>
        <div className="-mb-24 flex flex-col gap-8">
          <Box
            variant="secondary"
            className="flex min-h-[80px] items-center py-16"
          >
            <div className="flex w-full items-center gap-8">
              <SkeletonAvatar size="m" className="shrink-0" variant="square" />
              <SkeletonText size="xxl" width="160px" className="block" />
              <div className="ml-auto flex flex-col items-end gap-4">
                <SkeletonText width="100px" size="xl" className="h-24" />
                <SkeletonText width="50px" size="xl" />
              </div>
            </div>
          </Box>
          <Box
            variant="secondary"
            className="flex min-h-[80px] items-center py-16"
          >
            <div className="flex w-full items-center gap-8">
              <SkeletonAvatar size="m" className="shrink-0" />
              <SkeletonText size="xxl" width="200px" className="block" />
              <SkeletonTag width="100px" className="ml-auto block" />
            </div>
          </Box>
          <SkeletonTag width="50%" className="mb-24 mt-16" />
        </div>
      </PanelSection>

      <div>
        <SkeletonText size="xl" width="33%" className="block h-24" />
        <SkeletonText
          size="xl"
          width="50%"
          className="my-16 block min-h-[80px] w-full"
        />
      </div>
    </>
  );
};
